var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "#383D38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8902 21.2984L25.4601 17.6773H21.9494V15.3236C21.9494 14.3334 22.4395 13.3659 24.0068 13.3659H25.6254V10.2824C24.6828 10.132 23.7304 10.0507 22.7758 10.0391C19.8863 10.0391 17.9998 11.776 17.9998 14.9162V17.6773H14.7969V21.2984H17.9998V30.0568H21.9494V21.2984H24.8902Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3913 20.2005C33.3913 26.8673 28.4509 32.3789 22.0329 33.2733C21.4328 33.3565 20.8189 33.4 20.1956 33.4C19.4763 33.4 18.7698 33.3427 18.0819 33.2317C11.7989 32.2198 7 26.7702 7 20.2005C7 12.9102 12.9085 7 20.1966 7C27.4846 7 33.3931 12.9102 33.3931 20.2005H33.3913Z",
    fill: "#383D38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3504 12.8203L18.4364 20.9596L12.3125 27.5774H13.6912L19.0532 21.7837L23.3852 27.5774H28.0759L21.6477 18.9803L27.3482 12.8203H25.9695L21.0319 18.1562L17.0421 12.8203H12.3513H12.3504ZM14.3772 13.8359H16.5317L26.0472 26.5619H23.8928L14.3772 13.8359Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSquare);
export default __webpack_public_path__ + "static/media/twitter-square.2ab33dae4eec9c057fcc379000b239b1.svg";
export { ForwardRef as ReactComponent };